import { render, staticRenderFns } from "./kuran-form.vue?vue&type=template&id=4d3f4f6f&scoped=true&"
import script from "./kuran-form.vue?vue&type=script&lang=js&"
export * from "./kuran-form.vue?vue&type=script&lang=js&"
import style0 from "./kuran-form.vue?vue&type=style&index=0&id=4d3f4f6f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f4f6f",
  null
  
)

export default component.exports